import React, { useContext } from "react";
import { format, parseISO } from "date-fns";
import { toast } from "react-toastify";

import { i18n } from "../../../translate/i18n";
import { CommentStatusBadge } from "./SocialChannelBadge";
import CommentThread from "./CommentThread";
import CommentReplyComposer from "./CommentReplyComposer";
import apiV2 from "../../../services/apiV2";
import { AuthContext } from "../../../context/Auth/AuthContext";

function formatTime(iso) {
	try {
		return format(parseISO(iso), "dd/MM HH:mm");
	} catch {
		return "";
	}
}

function AuthorAvatar({ name }) {
	const initial = (name || "?").charAt(0).toUpperCase();
	return (
		<span className="flex size-9 shrink-0 items-center justify-center rounded-full bg-default-200 text-sm font-semibold text-default-700 dark:bg-default-700 dark:text-default-200">
			{initial}
		</span>
	);
}

export default function CommentFeedItem({ comment, onReply, onUpdateStatus }) {

	const { user } = useContext(AuthContext);

	const handleReply = async (text) => {
		const payload = {
			commentId: comment.id,
			text,
			connectionId: comment.connectionId,
			userId: user.id
		}
		try {
			const { data } = await apiV2.post("/replyComment", payload)
			const ok = onReply(comment.id, text);
			toast.success("Comentario respondido com sucesso")
		} catch (err) {
			console.log(err)
		}

	};

	const isReplied = comment.status === "replied";

	return (
		<article className="border-b border-default-200 px-4 py-4 last:border-b-0 dark:border-default-700">
			<div className="mb-3 flex items-start gap-3">
				<AuthorAvatar name={comment.author?.name} />
				<div className="min-w-0 flex-1">
					<div className="flex flex-wrap items-center gap-2">
						<span className="text-sm font-semibold text-default-800 dark:text-default-100">
							{comment.author?.name}
						</span>
						<span className="text-xs text-default-500">
							{formatTime(comment.createdAt)}
						</span>
						<CommentStatusBadge status={comment.status} />
					</div>
					<p className="mt-1 whitespace-pre-wrap text-sm text-default-700 dark:text-default-300">
						{comment.body}
					</p>
				</div>
			</div>

			{(comment.replies || []).length > 0 && (
				<div className="mb-3 ml-12">
					<CommentThread comment={comment} hideMain />
				</div>
			)}

			<div className="mb-3 flex flex-wrap gap-2">
				{!isReplied && (
					<button
						type="button"
						className="btn btn-sm border border-default-200 text-default-700 dark:border-default-600"
						onClick={() => onUpdateStatus(comment.id, "replied")}
					>
						{i18n.t("socialComments.actions.markReplied")}
					</button>
				)}
				{isReplied && (
					<button
						type="button"
						className="btn btn-sm border border-default-200 text-default-700 dark:border-default-600"
						onClick={() => onUpdateStatus(comment.id, "open")}
					>
						{i18n.t("socialComments.actions.reopen")}
					</button>
				)}
			</div>
			 {!isReplied && (
				<div className="ml-0 md:ml-12">
					<CommentReplyComposer onSubmit={handleReply} />
				</div>
			)} 
		</article>
	);
}
